import RealtorCard from './RealtorCard'

export default RealtorCard



// WEBPACK FOOTER //
// ./src/components/RealtorCard/index.js